import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="relative w-10 h-10">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl"></div>
                <div className="absolute inset-0 bg-gradient-to-tr from-blue-500/20 to-transparent rounded-xl"></div>
                <div className="relative w-full h-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold text-white leading-tight">ICT TechSolutions</span>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              Melbourne's trusted IT consultancy specializing in O365, Azure, and Google Workspace solutions for small businesses.
            </p>
            <div className="pt-2">
              <a
                href="https://www.lenovo.com/au/en/business/lenovo-360/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white rounded-lg p-2 hover:shadow-lg hover:shadow-blue-500/20 transition-all duration-200"
                data-testid="lenovo-authorized-badge"
                aria-label="Lenovo 360 Authorized Reseller 2026"
              >
                <img
                  src="/badges/lenovo-360-authorized-2026.webp"
                  alt="Lenovo 360 Authorized Reseller 2026"
                  className="h-20 w-auto"
                  loading="lazy"
                />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-blue-400 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-blue-400 transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/hardware-specials" className="text-sm hover:text-blue-400 transition-colors duration-200">
                  Hardware Specials
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm hover:text-blue-400 transition-colors duration-200">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-blue-400 transition-colors duration-200">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li className="text-sm">Microsoft 365 Solutions</li>
              <li className="text-sm">Azure Cloud Services</li>
              <li className="text-sm">Google Workspace</li>
              <li className="text-sm">Cloud Migration</li>
              <li className="text-sm">IT Support & Training</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="mt-1 text-blue-400 flex-shrink-0" />
                <span className="text-sm">Melbourne, Victoria, Australia</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="mt-1 text-blue-400 flex-shrink-0" />
                <span className="text-sm">0401 024 062</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="mt-1 text-blue-400 flex-shrink-0" />
                <span className="text-sm">ani@icttechsolutions.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} ICT TechSolutions. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link to="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-200">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
